<template>
    <b-row id="topbar_component" class="topbar-component">
        <b-col id="header_exchange"
               class="header-exchange desktop-only"
               lg="6">
            <header-exchange></header-exchange>
        </b-col>
    </b-row>
</template>

<script>
    import HeaderExchange from './topbar/HeaderExchange.vue'

    export default {
        components: { HeaderExchange }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_colors.scss';

    .topbar-component{
        justify-content: center;
        padding: 0 30px;
    }

    .header-exchange{
        border-width: 0 1px 1px;
        border-style: solid;
        border-color: $base1;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/header/Topbar.vue